import { fetchWithApiKey } from "../../helpers/fetch";
import { types } from "../../types/types";

export const zoneTypesStartLoading = () => {
  return async(dispatch) => {
    const resp = await fetchWithApiKey( 'api/Catalogs/c_ZoneType');
    const body = await resp.json();
    if (body.success){
      dispatch( zoneTypeLoaded( body.data ) )
    }
  }
}

const zoneTypeLoaded = ( zoneTypes ) => ({
  type: types.zoneTypeStartLoading,
  payload: zoneTypes
})
